const isObject = (obj) => !!obj && obj.constructor === Object;

export default isObject;
